import React from 'react';
import PageWrapper from './PageWrapper';
import { Link } from 'react-router-dom';

function FinishedSurvey({ surveyCode }) {
	return (
		<PageWrapper title='Thank you for your participation!'>
			<div className='dpa-text' style={{ display: 'flex', flexDirection: 'column', gap: '25px', textAlign: 'left' }}>
				<p>We appreciate you taking the time to complete the AlkalmaUp Baseline Wellbeing Assessment. Your feedback is essential in helping us support your wellbeing journey. Our team will review the insights gathered and will be in touch shortly to discuss the next steps.</p>

				<p className='text-center'>Thank you for choosing AlkalmaUp</p>

				{surveyCode && (
					<div className='text-center py-4'>
						<Link to={`/${surveyCode}/results`} className='confirm-button inline-block mt-4' style={{ textDecoration: 'none' }}>
							View Your Responses
						</Link>
					</div>
				)}

				<div style={{ marginTop: '20px', textAlign: 'center' }}>
					<p>If you have any questions, please contact us at:</p>
					<p className='font-bold mt-[10px]'>
						<a href='mailto:help@alkalmahealth.com' style={{ textDecoration: 'none', color: 'inherit' }}>
							help@alkalmahealth.com
						</a>
					</p>
				</div>
			</div>
		</PageWrapper>
	);
}

export default FinishedSurvey;
